import PlayerAvatar from "./PlayerAvatar";
import { Crown } from "lucide-react";

// Ramar och emblem för säsongsplaceringar. 1–3 får guld/silver/brons, övriga en diskret stålram.
const THEMES = {
  1: { medal: "🥇", name: "Guld", ring: "from-amber-200 via-yellow-400 to-amber-600", glow: "shadow-[0_0_26px_rgba(251,191,36,0.6)]",
       chip: "bg-gradient-to-br from-amber-200 to-amber-500 text-slate-950 border-amber-100", text: "text-amber-300", block: "from-amber-400 to-amber-700" },
  2: { medal: "🥈", name: "Silver", ring: "from-slate-100 via-slate-300 to-slate-500", glow: "shadow-[0_0_18px_rgba(203,213,225,0.45)]",
       chip: "bg-gradient-to-br from-slate-100 to-slate-400 text-slate-950 border-slate-100", text: "text-slate-200", block: "from-slate-300 to-slate-600" },
  3: { medal: "🥉", name: "Brons", ring: "from-orange-300 via-amber-600 to-orange-800", glow: "shadow-[0_0_16px_rgba(234,138,60,0.45)]",
       chip: "bg-gradient-to-br from-orange-300 to-orange-700 text-slate-950 border-orange-200", text: "text-orange-300", block: "from-orange-500 to-orange-900" },
};
const DEFAULT = { medal: null, name: "", ring: "from-slate-600 to-slate-700", glow: "",
                  chip: "bg-slate-800 text-slate-300 border-slate-600", text: "text-slate-400", block: "from-slate-700 to-slate-800" };

export const rankTheme = (rank) => THEMES[rank] || DEFAULT;

// Avatar med ram. Topp 3 har tjock, glödande ram; alla får ett placeringsemblem.
export function FramedAvatar({ icon, name, rank, size = 48, crown = true }) {
  const th = rankTheme(rank);
  const pad = rank <= 3 ? 4 : 2;
  return (
    <div className={`relative inline-block rounded-full bg-gradient-to-br ${th.ring} ${th.glow}`} style={{ padding: pad }} data-testid={`framed-avatar-${rank}`}>
      <div className="rounded-full bg-slate-950" style={{ padding: 2 }}><PlayerAvatar icon={icon} name={name} size={size} /></div>
      {rank === 1 && crown && <Crown className="absolute left-1/2 -translate-x-1/2 text-amber-300 drop-shadow" style={{ top: -Math.round(size * 0.34), width: Math.round(size * 0.46), height: Math.round(size * 0.46) }} />}
      <span className={`absolute -bottom-1.5 -right-1.5 min-w-[22px] h-[22px] px-1 rounded-full border-2 text-[11px] font-black font-mono flex items-center justify-center ${th.chip}`}>{rank}</span>
    </div>
  );
}

// Litet märke bredvid ett namn, t.ex. "S1 🥇" eller "S1 #4"
export function SeasonChip({ badge }) {
  const th = rankTheme(badge.rank);
  return (
    <span data-testid={`season-chip-${badge.season}-${badge.rank}`} title={`Säsong ${badge.season}: plats ${badge.rank} av ${badge.of}`}
      className={`inline-flex items-center gap-0.5 px-1.5 py-[1px] rounded-full border text-[10px] font-mono font-bold leading-none ${badge.rank <= 3 ? th.chip : "bg-slate-800/80 text-slate-300 border-slate-600"}`}>
      S{badge.season}{badge.rank <= 3 ? ` ${th.medal}` : ` #${badge.rank}`}
    </span>
  );
}

export function SeasonChips({ badges }) {
  if (!badges || badges.length === 0) return null;
  return <span className="inline-flex gap-1 shrink-0">{[...badges].sort((a, b) => b.season - a.season).map((b) => <SeasonChip key={b.season} badge={b} />)}</span>;
}
